export default {
  getProductHeaders(config) {
    const userToken = config.user.token;
    return {
      'X-Nsft-Seven-Tenant-Uuid': config.tenantId,
      Authorization: `Bearer ${userToken}`,
    };
  },
};
